import SiteLayout from "@/components/feature/SiteLayout";
import JsonLd from "@/components/base/JsonLd";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import LatestLeaks from "@/pages/home/components/LatestLeaks";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import VerifyProcess from "@/pages/home/components/VerifyProcess";
import HotRanking from "@/pages/home/components/HotRanking";
import SubmitSection from "@/pages/home/components/SubmitSection";
import FaqSection from "@/pages/home/components/FaqSection";

const SITE = "https://esjxdt.cn";
const TITLE = "深夜爆料 | 匿名爆料线人投稿入口，深夜爆料内部知情者来源线索汇总";
const DESC =
  "深夜爆料专注接收线人、知情者与内部来源的匿名投稿线索，汇总圈内未公开的爆料信源与投稿渠道。想找深夜爆料线人、匿名知情者或内部来源，点开这里看最新线索整理与投稿指引。";

const faqItems = [
  {
    q: "投稿后我的身份会被暴露吗？",
    a: "不会。投稿入口不采集 IP 与设备指纹，表单中也没有任何强制身份字段。若你在正文里写到了可识别自身的信息，编辑会先做脱敏处理再归档。",
  },
  {
    q: "什么样的内容适合投稿？",
    a: "与行业运作相关、可被描述清楚的事实类信息最合适，例如排期安排、结算方式、执行流程、合作结构。纯粹的传闻、无法描述来源的二手消息，我们会归入低优先级。",
  },
  {
    q: "「待核验」是不是说明这条线索不可信？",
    a: "不是。它只表示目前只有一位来源提供了说法，尚未找到第二个独立信源。等级会随着新证据出现而调整，我们会在原线索下方持续更新。",
  },
  {
    q: "你们会删除已经发布的线索吗？",
    a: "会。若当事人提供了可推翻关键事实的证据，我们会更正或下线相关条目，并在同一位置留下更正说明，不做静默删除。",
  },
  {
    q: "可以匿名投稿多条线索吗？",
    a: "可以，每条线索单独提交一次即可，便于我们分别建立编号与核验状态。同一事件的不同环节，也建议拆成多条分别说明。",
  },
  {
    q: "投稿之后多久能看到结果？",
    a: "夜班编辑会在 24 小时内完成初步整理与分级。进入核验阶段的线索，通常在 3 至 7 日内决定是否公开发布；未发布的线索不会丢弃，会保留在待核区。",
  },
];

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${SITE}/#website`,
      url: `${SITE}/`,
      name: "深夜爆料",
      inLanguage: "zh-CN",
      description: DESC,
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE}/leaks?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      "@id": `${SITE}/#organization`,
      name: "深夜爆料编辑室",
      url: `${SITE}/`,
      email: "tips@midnight-leaks.example.com",
      description: "接收线人、知情者与内部来源匿名投稿，并对线索进行脱敏、交叉印证与分级整理的编辑团队。",
    },
    {
      "@type": "FAQPage",
      "@id": `${SITE}/#faq`,
      mainEntity: faqItems.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <SiteLayout>
      <title>{TITLE}</title>
      <meta name="description" content={DESC} />
      <meta
        name="keywords"
        content="深夜爆料,深夜爆料线人,深夜爆料知情者,深夜爆料内部,深夜爆料来源,深夜爆料匿名,深夜爆料投稿"
      />
      <link rel="canonical" href={`${SITE}/`} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="深夜爆料 | 匿名爆料线人投稿入口" />
      <meta property="og:description" content={DESC} />
      <meta property="og:url" content={`${SITE}/`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="深夜爆料 | 匿名线人投稿入口" />
      <meta name="twitter:description" content={DESC} />
      <JsonLd data={homeJsonLd} />

      <Hero />
      <Ticker />
      <LatestLeaks />
      <CategoryGrid />
      <VerifyProcess />
      <HotRanking />
      <SubmitSection />
      <FaqSection />
    </SiteLayout>
  );
}